import {
  AuditOutlined,
  BookOutlined,
  CommentOutlined,
  DoubleRightOutlined,
  EllipsisOutlined,
  FolderOpenOutlined,
  FormOutlined,
  MailOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons';
import { Button, Dropdown } from 'antd';

import useAPIQuery from '../../api/useAPIQuery';
import CandidateWhatsAppLabel from '../../components/CandidateWhatsAppLabel';
import { CandidateDetail } from '../../types';

type Props = {
  candidateId: CandidateDetail['id'];
  candidateName: CandidateDetail['name'];
  enableAlchemerIntegration?: boolean;
  hasViewed: boolean;
  onSelectClick: () => void;
  onSendAnnotationClick: () => void;
  onSendEmailClick: () => void;
  onSendTestsClick: () => void;
  onSendCustomTestsClick: () => void;
  onMarkAsUnviewedClick: () => void;
};

export default function TalentPoolTableActions({
  candidateId,
  enableAlchemerIntegration,
  candidateName,
  hasViewed,
  onSelectClick,
  onSendAnnotationClick,
  onSendEmailClick,
  onSendTestsClick,
  onSendCustomTestsClick,
  onMarkAsUnviewedClick,
}: Props) {
  // useAPIQuery that only gets data from the cache
  const cachedCandidate = useAPIQuery(`/candidates/${candidateId}/`, {
    enabled: false,
  });

  return (
    <Dropdown
      menu={{
        onClick: ({ key }) => {
          switch (key) {
            case 'select':
              onSelectClick();
              break;
            case 'annotation':
              onSendAnnotationClick();
              break;
            case 'email':
              onSendEmailClick();
              break;
            case 'tests':
              onSendTestsClick();
              break;
            case 'custom-tests':
              onSendCustomTestsClick();
              break;
            case 'mark-as-unviewed':
              onMarkAsUnviewedClick();
              break;
          }
        },
        items: [
          { key: 'select', icon: <DoubleRightOutlined />, label: 'Triar para vaga' },
          { key: 'annotation', icon: <FormOutlined />, label: 'Registrar comentário' },
          {
            key: 'send',
            label: 'Enviar e-mail',
            icon: <MailOutlined />,
            children: [
              { key: 'email', icon: <CommentOutlined />, label: 'Enviar comunicação' },
              { key: 'tests', icon: <AuditOutlined />, label: 'Enviar testes' },
              ...(enableAlchemerIntegration
                ? [
                    {
                      key: 'custom-tests',
                      icon: <BookOutlined />,
                      label: 'Enviar testes customizados',
                    },
                  ]
                : []),
            ],
          },
          {
            key: 'whatsapp',
            icon: <WhatsAppOutlined />,
            disabled: !cachedCandidate.data?.phone_contacts?.find(
              (phoneContact) => phoneContact.type === 'PERSONAL'
            ),
            label: <CandidateWhatsAppLabel candidateId={candidateId} />,
          },
          {
            key: 'mark-as-unviewed',
            icon: <FolderOpenOutlined />,
            disabled: !hasViewed,
            label: 'Marcar como não visto',
          },
        ],
      }}
    >
      <Button type="text" icon={<EllipsisOutlined />} aria-label={`Ações para ${candidateName}`} />
    </Dropdown>
  );
}
